import SentinelOriana from '@/pages/sentinel-oriana/SentinelOriana.vue';

export default {
  path: '/sentinel-oriana',
  name: 'SentinelOriana',
  component: SentinelOriana,
  meta: {
    // hideMainMenu: true,
    role: {
      sectorId: 'dashboard',
    },
  },
};
